import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page27() {
  useEffect(() => {
    document.title = "Маяк — Страница 26"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page25" />
        <ForwardLink href="/page27" />
      </div>

      <p style={{ textAlign: "right" }}>26.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        (поет)<br/>
        <i>Масляные контейнеры я полирую до тех пор пока,<br/>
        Моя бедная спина не сломается и начнет болеть;<br/>
        и продолжаю...</i>
      </p>
      <p>Он толкает изо всех сил... Тачка падает...</p>
      <p>Уголь разбросан повсюду. МОЛОДОЙ стоит на месте.</p>
      <p>Он хочет кричать.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>МОЛОДОЙ и СТАРИК едят свой скрод и картошку в тишине.</p>
      <p>ДОЖДЬ И ВЕТЕР БЛЭР ПРЯМО ЗА ИХ ХРУПКИМИ СТЕНАМИ.</p>
      <p>Напряженность.</p>
      <p>Задержка.</p>
      <p>Раскаты грома.</p>
      <p>ЧЕРНЫЙ ЭКРАН.</p>
      <br/>
      <p>СНАРУЖИ. БАШНЯ МАЯКА – ДЕНЬ</p>
      <p>
        РАКУРС НА: СТАРИК смотрит вниз с ПОДИУМА (смотровой площадки) башни,<br/>
        курит трубку. Позади него светит солнце.
      </p>
      <p>
        КАМЕРА СПУСКАЕТСЯ ВНИЗ  К: МОЛОДОЙ сидит на КУХОННОМ СТУЛЕ, поддерживаемом<br/>
        веревками, прикрепленными к “jerky” КРЕПЕЖУ И СТРАХОВКЕ. Одно из<br/>
        колес слетает со шкива.
      </p>
      <p>
        МОЛОДОЙ белит башню на высоте около 50 футов<br/>
        над землей. На другой веревке болтается ведро с побелкой.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Держи их спокойно, парень.
      </p>
      <p>МОЛОДОЙ не может. Как обычно, ветер дует дико.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p>
        "Кисть" — палка с кисточкой из конского волоса на конце —<br/>
        трясется в его руках.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Побелка должна быть ровной, парень.<br/>
        Яркой! Сияющей!<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>26.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page25" />
        <ForwardLink href="/page27" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710016214/the-lighthouse-script/vape2lokcq7wu3bzvjow.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page27;
